import * as swcHelpers from '@swc/helpers';
import '../operations/queries/get-accessories-by-slug.js';
import '../operations/queries/get-contact-lens-by-slug.js';
import '../operations/queries/get-frames-by-slug.js';
import '../operations/queries/get-solutions-by-slug.js';
import { GET_SUNGLASSES_BY_SLUG } from '../operations/queries/get-sunglasses-by-slug.js';
import '../operations/queries/get-ready-reader-by-slug.js';
import '../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../operations/queries/get-manufacturer-by-key.js';

const getSunglassesBySlug = function() {
    var _ref = swcHelpers.asyncToGenerator(function*({ client , slug , locale  }) {
        const queryResult = yield client.query({
            query: GET_SUNGLASSES_BY_SLUG,
            variables: {
                slug
            },
            context: {
                headers: {
                    'Accept-Language': locale
                }
            }
        });
        return queryResult;
    });
    return function getSunglassesBySlug(_) {
        return _ref.apply(this, arguments);
    };
}();

export { getSunglassesBySlug };
//# sourceMappingURL=getSunglassesBySlug.js.map
